<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Reset Password v1 -->
      <b-card class="mb-0">

        <!-- logo -->
        <b-link class="brand-logo">
          <VOVAT-logo :img-width="120" />
          <h2 class="brand-text text-primary ml-1">
            VOVAT
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          Đặt lại mật khẩu 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          Mật khẩu mới của bạn phải khác với mật khẩu đã sử dụng trước đó
        </b-card-text>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form
            method="POST"
            class="auth-reset-password-form mt-2"
            autocomplete="off"
            @submit.prevent="validationForm"
          >

            <!-- password -->
            <b-form-group
              label="Mật khẩu mới"
              label-for="reset-password-new"
            >
              <validation-provider
                #default="{ errors }"
                name="password"
                vid="password"
                rules="required|min:6|max:50"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="reset-password-new"
                    v-model="password"
                    :type="password1FieldType"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    name="reset-password-new"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="password1ToggleIcon"
                      @click="togglePassword1Visibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- confirm password -->
            <b-form-group
              label-for="reset-password-confirm"
              label="Xác nhận mật khẩu"
            >
              <validation-provider
                #default="{ errors }"
                name="confirm_password"
                rules="required|confirmed:password"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="reset-password-confirm"
                    v-model="confirm_password"
                    :type="password2FieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="reset-password-confirm"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="password2ToggleIcon"
                      @click="togglePassword2Visibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              block
              type="submit"
              variant="primary"
            >
              Đặt lại mật khẩu
            </b-button>
          </b-form>
        </validation-observer>

        <p class="text-center mt-2">
          <b-link :to="{ name: 'auth-login' }">
            <feather-icon icon="ChevronLeftIcon" /> Trở về trang đăng nhập
          </b-link>
        </p>

      </b-card>
      <!-- /Reset Password v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VOVATLogo from '@core/layouts/components/Logo.vue'
import {
  BCard, BCardTitle, BCardText, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BLink, BFormInput, BButton,
} from 'bootstrap-vue'
import {
  required, min, max, strongPassword,
} from '@validations'
import useJwt from '@/auth/jwt/useJwt'
import { showToast } from '@/@core/utils/utils'

export default {
  components: {
    VOVATLogo,
    BCard,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      password: '',
      confirm_password: '',
      // validation
      required,
      strongPassword,
      min,
      max,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
    }
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    validationForm() {
      const { token } = this.$route.query;
      const cookieReset = this.$cookies.get('VOVNewsPortalResetPassword');
      if (token === undefined || token === '') {
        return showToast('Token không hợp lệ');
      }
      if (cookieReset !== undefined && cookieReset !== '' && cookieReset !== null) {
        return showToast('Bạn đã yêu cầu lấy lại mật khẩu trước đó');
      }
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          useJwt
            .resetpass({
              password: this.password,
              token,
            })
            .then(response => {
              if (response.status === 200) {
                this.$cookies.set('VOVNewsPortalResetPassword', 1, 5 * 60); // 5 min
                showToast(response.data.message, {
                  variant: 'success',
                })
                this.$router.push({ name: 'auth-login' });
              } else {
                this.loading = false
                showToast(response.data.message)
              }
            })
        }
      })
      return false;
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
